import { useMutation } from '@tanstack/react-query';
import { FileParameter } from 'src/api/FiretrolApiClient';
import { attachmentApiClient } from 'src/api/FiretrolApiClientInstances';
import { triggerDownload } from 'src/utils';

/** @registry Uploads a file to the temp attachment store under a resource type id (e.g. `post`, `meeting-topics`). */
export function useUploadTempAttachment(typeId: string) {
  return useMutation({
    mutationFn: (file: FileParameter) =>
      attachmentApiClient.uploadTempFile(typeId, file),
    meta: { suppressErrorToast: true, errorContext: 'upload attachment' },
  });
}

/** @registry Downloads an attachment to the browser. */
export function useDownloadAttachment() {
  return useMutation({
    mutationFn: async (id: string) => {
      const result = await attachmentApiClient.download(id);
      triggerDownload(result.url, result.name);
      return result;
    },
    meta: { errorContext: 'download attachment' },
  });
}

/** @registry Resolves an attachment's signed URL without triggering a browser download; for `FileDrop`'s `downloadFile`. */
export function useResolveAttachmentUrl() {
  return useMutation({
    mutationFn: (id: string) => attachmentApiClient.download(id),
    meta: { errorContext: 'attachment url' },
  });
}
